import React from 'react';
import { BranchesOutlined, ScissorOutlined, CheckSquareOutlined, AppstoreOutlined, ShoppingOutlined } from '@ant-design/icons';
import { ModuleManifest } from '@/lib/modules/types';

export * from './types';

export const MAKLOON_MANIFEST: ModuleManifest = {
  id: 'makloon',
  name: 'Paket 2: Modul Makloon & Produksi CMT',
  tier: 2,
  version: '1.0.0',
  description:
    'Modul Manajemen Makloon: Master Produk Jadi, SPK Multi-Product dengan Nilai Buyback, Alokasi & Pengeluaran Bahan Bertahap, Penerimaan Hasil Jahit QC, Alur Approval Manager, dan Termin Pembayaran Finance AP.',
  dependencies: ['procurement'],
  routes: ['/makloon'],
  navigation: [
    {
      key: 'makloon-parent',
      label: 'Produksi Makloon',
      path: '/makloon',
      icon: React.createElement(BranchesOutlined),
      allowedRoles: ['ADMIN', 'OWNER', 'PURCHASER', 'WAREHOUSE', 'FINANCE_ADMIN', 'FINANCE_MANAGER'],
      children: [
        {
          key: 'makloon-dashboard',
          label: 'Daftar SPK',
          path: '/makloon',
          icon: React.createElement(BranchesOutlined),
          allowedRoles: ['ADMIN', 'OWNER', 'PURCHASER', 'WAREHOUSE', 'FINANCE_ADMIN', 'FINANCE_MANAGER'],
        },
        {
          key: 'makloon-products',
          label: 'Katalog Produk',
          path: '/makloon?tab=products',
          icon: React.createElement(AppstoreOutlined),
          allowedRoles: ['ADMIN', 'PURCHASER'],
        },
        {
          key: 'makloon-dispatches',
          label: 'Surat Jalan Bahan',
          path: '/makloon?tab=dispatch',
          icon: React.createElement(ShoppingOutlined),
          allowedRoles: ['ADMIN', 'WAREHOUSE'],
        },
        {
          key: 'makloon-qc',
          label: 'Penerimaan & QC',
          path: '/makloon?tab=receipts',
          icon: React.createElement(CheckSquareOutlined),
          allowedRoles: ['ADMIN', 'WAREHOUSE'],
        },
      ],
    },
  ],
};

export default MAKLOON_MANIFEST;
